import { useTranslation } from 'react-i18next';

import { Card } from '@/app/components/ui/Card';
import { PageHeader } from '@/app/components/ui/PageHeader';
import { Consents } from '@/features/profile/Consents';
import { useMe } from '@/features/me/MeContext';

/**
 * `/profile/consents` (§ Profiel): the caller's own consent answers — split
 * out of the Profiel tab into its own menu item since it's a distinct task
 * (answering requests), not part of the personal-details form.
 */
export function ConsentsPage() {
  const { t } = useTranslation();
  const { me } = useMe();
  const pendingCount = (me.pending_consents ?? []).length;

  return (
    <section className="flex flex-col gap-6">
      <PageHeader
        title={t('consents.title')}
        meta={pendingCount > 0 ? t('profile.pendingBadge', { count: pendingCount }) : undefined}
      />

      <Card>
        <Consents />
      </Card>
    </section>
  );
}
